import React from 'react';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import {
  FaEnvelope,
  FaWhatsapp,
  FaHeadset,
  FaClock,
  FaArrowRight,
  FaComments,
  FaPhoneAlt
} from 'react-icons/fa';
import '../../../css/custom-scrollbar.css'

const B2bSupport = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();

  const supportChannels = [
    {
      icon: <FaEnvelope className="w-4 h-4 text-white" />,
      title: 'Email Support',
      description: 'Comprehensive support via email. Detailed responses within 24 hours.',
      contact: 'support@pickupxpress.com',
      link: 'mailto:support@pickupxpress.com',
    },
    {
      icon: <FaWhatsapp className="w-4 h-4 text-white" />,
      title: 'WhatsApp Support',
      description: 'Instant messaging support for quick resolutions.',
      contact: '+91XXXXXX0087',
      link: 'https://wa.me/message/LCC4KAGD5JFUC1',
    }
  ];

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 ${isDarkMode ? 'bg-black' : 'bg-white'} md:bg-transparent mt-4 md:w-64 md:z-20 border-r ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}
        
        <div className={`flex-1 ${isDarkMode ? 'bg-black' : 'bg-gray-100'} overflow-hidden flex flex-col`}>
          <div className="max-w-4xl mx-auto w-full flex-1 flex flex-col justify-center px-3 py-3 overflow-y-auto custom-scrollbar">

            {/* Header Section */}
            <div className="text-center mb-3">
              <div className="relative inline-block">
                <div className="relative inline-flex items-center justify-center w-12 h-12 rounded-xl border ${isDarkMode ? 'border-white/20' : 'border-black/20'} mb-1.5">
                  <FaHeadset className={`w-6 h-6 ${isDarkMode ? 'text-white' : 'text-black'}`} />
                </div>
              </div>
              <h1 className={`text-lg sm:text-xl font-extrabold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                Customer Support
              </h1>
              <p className={`text-[11px] max-w-xl mx-auto mt-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>
                Our dedicated support team is here to help with any questions or concerns you may have.
              </p>
            </div>

            {/* Primary Support Channels */}
            <div className="grid md:grid-cols-2 gap-3 mb-3">
              {supportChannels.map((channel, index) => (
                <div
                  key={index}
                  className={`group relative overflow-hidden border rounded-xl transition-all duration-300 hover:-translate-y-0.5 ${
                    isDarkMode 
                      ? 'border-white/10 bg-black hover:border-white/30' 
                      : 'border-black/10 bg-white hover:border-black/30'
                  }`}
                >
                  <div className="relative p-4 space-y-1.5">
                    <div className={`p-2 rounded-lg inline-block ${isDarkMode ? 'bg-white' : 'bg-black'}`}>
                      {channel.icon}
                    </div>
                    <h2 className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                      {channel.title}
                    </h2>
                    <p className={`text-[10px] leading-relaxed ${isDarkMode ? 'text-white/60' : 'text-black/60'}`}>
                      {channel.description}
                    </p>
                    <div className="flex items-center space-x-2">
                      <span className={`font-medium text-[10px] ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                        {channel.contact}
                      </span>
                    </div>
                    <a
                      href={channel.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`inline-flex items-center justify-between px-3 py-1.5 rounded-lg text-[10px] font-semibold transition-all duration-300 hover:shadow-md ${
                        isDarkMode 
                          ? 'bg-white text-black hover:bg-white/90' 
                          : 'bg-black text-white hover:bg-black/90'
                      }`}
                    >
                      <span>Contact Support</span>
                      <FaArrowRight className={`ml-1.5 w-3 h-3 transform group-hover:translate-x-0.5 transition-transform duration-300`} />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Business Hours Card */}
            <div className={`border rounded-xl overflow-hidden transition-all duration-300 ${
              isDarkMode ? 'border-white/10 bg-black' : 'border-black/10 bg-white'
            }`}>
              <div className="p-3 flex items-center gap-3 flex-wrap sm:flex-nowrap">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  isDarkMode ? 'bg-white' : 'bg-black'
                }`}>
                  <FaClock className={`w-4 h-4 ${isDarkMode ? 'text-black' : 'text-white'}`} />
                </div>
                <div>
                  <h3 className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                    Business Hours
                  </h3>
                  <p className={`text-[11px] font-medium mt-0.5 ${isDarkMode ? 'text-white/80' : 'text-black/80'}`}>
                    Monday to Saturday : 9:00 AM - 6:00 PM
                  </p>
                  <p className={`text-[9px] mt-0.5 ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>
                    For urgent matters outside business hours, our WhatsApp support channel provides immediate assistance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bSupport;